import { Trans } from "@lingui/macro";
import React from "react";
import styled from "styled-components";
import "swiper/css";
import { heading2, heading4Alt } from "~/guidelines/Typography";
import asset1 from "../_assets/hero-section/asset-1.png";
import asset2 from "../_assets/hero-section/asset-2.png";
import asset3 from "../_assets/hero-section/asset-3.png";
import asset4 from "../_assets/hero-section/asset-4.png";
import asset5 from "../_assets/hero-section/asset-5.png";

const HeroSectionWrapper = styled.section`
  padding: ${({ theme }) => theme.spacing(18, 0, 0, 0)};
  max-width: 1440px;
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: ${({ theme }) => theme.spacing(18, 18, 0, 18)};
  }
`;

const Heading = styled.h4`
  ${heading4Alt};
  text-align: center;
`;

const Title = styled.h1`
  ${heading2};
  font-size: 40px !important;
  line-height: 50px !important;
  text-align: center;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${({ theme }) => theme.spacing(10)};
  padding-left: ${({ theme }) => theme.spacing(5)};
  padding-right: ${({ theme }) => theme.spacing(5)};

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding-left: 0;
    padding-right: 0;
    font-size: 50px !important;
    line-height: 60px !important;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: flex-start; /* Ajouté ici */
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};
  overflow: hidden;
  max-width: 1200px;
  margin: 0 auto;
`;

const Image = styled.img`
  width: 100%;
  height: 160px;
  object-fit: cover;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    height: 220px;
  }
`;

const HeroSection: React.FC = () => {
  return (
    <HeroSectionWrapper>
      <Heading>
        <Trans>Investors,</Trans>
      </Heading>

      <Title>
        <Trans>Together, let’s reinvent the hotel industry of tomorrow</Trans>
      </Title>

      <ImageContainer>
        {[asset1, asset2, asset3, asset4, asset5].map((img, idx) => (
          <Image key={idx} src={img.src} alt="Photo d'un hôtel" />
        ))}
      </ImageContainer>
    </HeroSectionWrapper>
  );
};

export default HeroSection;
